export default {
  // Common operation feedback
  'pages.common.add.success': 'Created successfully',
  'pages.common.edit.success': 'Updated successfully',
  'pages.common.edit.fail': 'Update failed',
  'pages.common.update.success': 'Updated successfully',
  'pages.common.update.error': 'Update failed',

  // Welcome page
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',

  // Exception pages
  'pages.403.subTitle': 'Sorry, you are not authorized to access this page.',
  'pages.403.buttonText': 'Back Home',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.500.subTitle': 'Sorry, something went wrong.',
  'pages.500.buttonText': 'Back Home',

};
